import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(() => {
	 if (wixLocation.url === wixLocation.baseUrl) {
	 	$w('#defaultHeaderStrip').show();
 $w('#scrollingHeaderStrip').hide();
} else if(wixWindow.formFactor === 'Desktop') {
		$w('#defaultHeaderStrip').hide(); 		
		$w('#scrollingHeaderStrip').show();
 	}

	$w('#search').onKeyPress((event) => {
		if (event.key === 'Enter') {
			wixLocation.to('https://www.mikaelareuben.com/recipes?search=' + encodeURIComponent(event.target.value));
		}
	});
});
